<template>
  <Collapse simple class="collapse-warpper" value=1>
    <Panel name="1" class="collapse-panel">
      <span class="panel-title">{{initdata.title}}</span>
      <div slot="content" >
        <!-- 状态列表 -->
        <div>
          <div
            v-for="(item,index) in stateList"
            :data-index="index"
            :key="item.id"
          >
            <Checkbox v-model="item.model" class="sort-checkbox" @on-change="stateClick">
                <span class="sort-label">{{item.label}}</span>
            </Checkbox>
          </div>
        </div>
      </div>
    </Panel>
  </Collapse>
</template>


<script>
export default {
  mounted() {},
  props: ["initdata", "filterListIndex"],
  data() {
    return {
      actived: false,
      discountType:[],
      licensePicUrl:[],
      appType:[]
    };
  },
  methods: {
    stateClick(e) {
      this.$emit("event", {
        fn: "filterTypeChange",
        params: {
            list:this.stateList
        }
      });
    },
    reset() {
      for (let item of this.stateList) {
        item.model = false;
      }
      this.$emit("event", {
        fn: "reset"
      });
    }
  },
  computed: {
    stateList: function() {
      return this.initdata.stateList;
    }
  },
  watch: {
    initdata() {
      this.initdata.stateList.forEach(item => {
        item.model = false;
      });
    }
  },
  components: {}
};
</script>
<style scoped lang="less">
@import "./collapse.less";

.sort-checkbox {
  margin-top: 10px;
}

</style>